// extracted by mini-css-extract-plugin
module.exports = {"icon":"search_icon_9hYPJ"};